import { Action, InstantAction } from "./userActions";

export const isAction = (action: Action | InstantAction): action is Action => {
  return action.type === "action";
};
